import {
  createEntityAdapter,
  createSelector,
} from '@reduxjs/toolkit';

import { apiSlice } from '../../../api/apiSlice';

// create a normalized state
const s3Adapter = createEntityAdapter({
  selectId: e => {
    let id;
    id = e.ETag;
    return id;
  },
});
const initialState = s3Adapter.getInitialState();

export const s3Slice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    /** @GET */
    getFiles: builder.query({
      query: payload => ({
        url: `/s3/files/${payload.upload_type}/${payload.prefix}`,
      }),
      transformResponse: responseData => {
        return s3Adapter.setAll(initialState, responseData);
      },
      providesTags: (result, error, arg) => [
        { type: 's3Files', id: 'LIST' },
        ...result.ids.map(id => ({ type: 's3Files', id })),
      ],
    }),
    removeFileFromBucket: builder.mutation({
      query: payload => ({
        url: `/s3/deletefile`,
        method: 'POST',
        body: payload,
      }),
    }),
  }),
});

export const { useGetFilesQuery, useRemoveFileFromBucketMutation } =
  s3Slice;

// setup selectors
export const selectFilesResult = s3Slice.endpoints.getFiles.select();

const selectFilesResultData = createSelector(
  selectFilesResult,
  fileResult => fileResult.data
);

export const { selectAll: selectFiles } = s3Adapter.getSelectors(
  state => selectFilesResultData(state) ?? initialState
);
